import { useSelector } from 'react-redux';
import { FiTrash2 } from '@react-icons/all-files/fi/FiTrash2';
import { Tooltip } from 'antd';
import { BUTTON_VARIANT_DARK } from '../../../../components/forms/ZorbaButton/constants';
import {
  ZorbaSelect,
  ZorbaInput,
  ZorbaButton,
} from '../../../../components/forms';

export const Webhooks = ({
  webhooks,
  setWebhooks,
  handleCancel,
  handleSave,
  isLoading,
}) => {
  const { isSuperUser } = useSelector(({ AuthReducer }) => AuthReducer);
  const onAddWebhook = () => {
    const newWebhooks = [...(webhooks || []), { events: [], url: '' }];
    setWebhooks(newWebhooks);
  };

  const onWebhookChange = (idx, key, value) => {
    const newWebhooks = webhooks.map((webhook, i) => {
      if (i === idx) {
        // eslint-disable-next-line no-param-reassign
        webhook[key] = value;
      }
      return webhook;
    });
    setWebhooks(newWebhooks);
  };
  const onRemoveWebhook = (idx) => {
    setWebhooks(webhooks.filter((webhook, i) => idx !== i));
  };

  return (
    <div className="webhooks">
      {(webhooks || []).map((webhook, idx) => (
        <Tooltip
          title={
            !isSuperUser
              ? 'Contact a Zorba representative to assist you in adjusting this setting'
              : ''
          }
        >
          <div className="webhook">
            <ZorbaSelect
              disabled={!isSuperUser}
              mode="multiple"
              placeholder="New offer request"
              label="Events to subscribe"
              options={[
                { label: 'New offer request', value: 'offer_request' },
                { label: 'Seller countered offer', value: 'counter_offer' },
              ]}
              value={webhook.events}
              onChange={(newVal) => onWebhookChange(idx, 'events', newVal)}
            />
            <ZorbaInput
              disabled={!isSuperUser}
              label="Webhook URL"
              placeholder="https://mylambdafunction-abcdef123456.us-east-1.on.aws/create-lead"
              value={webhook.url}
              onChange={(e) => onWebhookChange(idx, 'url', e.target.value)}
            />
            <FiTrash2
              className="remove-btn"
              onClick={() => {
                if (isSuperUser) {
                  onRemoveWebhook(idx);
                }
              }}
            />
          </div>
        </Tooltip>
      ))}
      <div className="buttons-container">
        <ZorbaButton
          disabled={!isSuperUser || isLoading}
          className="create-webhook-btn"
          fullWidth={false}
          onClick={onAddWebhook}
          variant={BUTTON_VARIANT_DARK}
        >
          Add webhook
        </ZorbaButton>
        {webhooks?.length > 0 && (
          <div className="action-buttons">
            <ZorbaButton
              disabled={!isSuperUser || isLoading}
              fullWidth={false}
              onClick={handleSave}
              variant={BUTTON_VARIANT_DARK}
              loading={isLoading}
            >
              Save
            </ZorbaButton>
            <ZorbaButton
              className="create-webhook-btn"
              fullWidth={false}
              onClick={handleCancel}
              variant={BUTTON_VARIANT_DARK}
              disabled={isLoading}
            >
              Cancel
            </ZorbaButton>
          </div>
        )}
      </div>
    </div>
  );
};
